import React from 'react';
import Form from 'react-bootstrap/Form';
import { useField } from 'formik';

const InputDate = (props) => {

    const [field, meta, helper] = useField(props);

    return (
        <Form.Group controlId={`form-${props.name}`}>
            <Form.Label>{props.label}</Form.Label>
            <Form.Control
                type="date"
                name={props.name}
                value={field.value === '' ? props.defaultValue : field.value}
                onChange={field.onChange}
                isValid={props.defaultValue !== '' && !meta.error && meta.touched}
                isInvalid={!!meta.error}
                disabled={props.disabled}
            />
            <Form.Control.Feedback type="invalid"> {meta.error} </Form.Control.Feedback>
            
        </Form.Group>
    );

}

export default InputDate;